import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';

import { renderableType } from '../proptypes/prop-types';
import { buildClassNames, buildClassNameModifiers } from '../util/utils';
import './navItem.scss';

const blockClassName = 'navItem';
const labelIconClassName = 'navItem__labelIcon';

export class NavItem extends Component {
  static propTypes = {
    /** @ignore */
    children: renderableType,
    /** @ignore */
    className: PropTypes.string,
    /** @ignore */
    isNavItem: PropTypes.bool,
    /** Indicates that the nav item represents the current page in the site hierarchy */
    current: PropTypes.bool,
    /** Indicates that the nav item is disabled */
    disabled: PropTypes.bool,
    /** The icon to be rendered next to the label */
    icon: renderableType,
    /** The content displayed for the nav item */
    label: renderableType,
    /** Function executed on click */
    onClick: PropTypes.func,
    /** Text displayed on hover */
    title: PropTypes.string,
  };
  static defaultProps = {
    isNavItem: true,
    current: false,
    disabled: false,
  };

  handleKeyDown = (e) => {
    if (this.props.onClick) {
      if (e.key === 'Enter') {
        e.stopPropagation();
        const savedEvent = e;
        this.props.onClick(savedEvent);
      }
    }
  };

  render() {
    const {
      children,
      className,
      isNavItem,
      current,
      disabled,
      icon,
      label,
      onClick,
      title,
      activeClassName,
      ...other
    } = this.props;
    return (
      <div
        role='menuitem'
        tabIndex={disabled ? -1 : 0}
        className={buildClassNames(
          className,
          buildClassNameModifiers(blockClassName, { current }, { disabled }),
          blockClassName,
        )}
        title={title}
        onClick={onClick}
        onKeyDown={this.handleKeyDown}
        {...other}
      >
        <span>
          {icon && cloneElement(icon, { className: labelIconClassName }) }
          {children || label}
        </span>
      </div>
    );
  }
}
